// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expired-token {
  background: linear-gradient(47.69deg, rgba(103, 191, 198, 0.45) 16.16%, rgba(142, 198, 64, 0.45) 83.81%);
  width: 100%;
  height: 100vh;
  text-align: center;
}
.expired-token img {
  width: 300px;
}
.expired-token .expired-token__text {
  font-family: Roboto-Regular;
  font-size: 30px;
  line-height: 1.3;
  margin-top: 35px;
}
.expired-token .expired-token__button {
  font-family: inherit;
  font-weight: 700;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  margin-top: 25px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 12px 0px;
  padding: 15px 20px;
  min-height: 40px;
  background-color: rgb(0, 123, 94);
  color: rgb(251, 255, 254);
  border-radius: 4px;
  font-size: 25px;
}
.expired-token .expired-token__press-enter {
  display: inline-table;
  margin-left: 2%;
}
.expired-token .expired-token__press-enter .congratulations__press-enter-tex {
  margin: 0px;
  max-width: 100%;
  font-weight: unset;
  font-size: 12px;
  line-height: 16px;
  color: rgb(34, 35, 35);
  font-family: sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/expired-token/expired-token.component.scss"],"names":[],"mappings":"AAAA;EACI,wGAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AACJ;AACI;EACI,YAAA;AACR;AAEI;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAAR;AAGI;EACI,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,+CAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AADR;AAII;EACI,qBAAA;EACA,eAAA;AAFR;AAIQ;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;AAFZ","sourcesContent":[".expired-token {\n    background: linear-gradient(47.69deg, rgba(103, 191, 198, 0.45) 16.16%, rgba(142, 198, 64, 0.45) 83.81%);\n    width: 100%;\n    height: 100vh;\n    text-align: center;\n\n    img {\n        width: 300px;\n    }\n\n    .expired-token__text {\n        font-family: Roboto-Regular;\n        font-size: 30px;\n        line-height: 1.3;\n        margin-top: 35px;\n    }\n\n    .expired-token__button {\n        font-family: inherit;\n        font-weight: 700;\n        cursor: pointer;\n        outline: none;\n        border: 1px solid transparent;\n        margin-top: 25px;\n        box-shadow: rgb(0 0 0 / 10%) 0px 3px 12px 0px;\n        padding: 15px 20px;\n        min-height: 40px;\n        background-color: rgb(0, 123, 94);\n        color: rgb(251, 255, 254);\n        border-radius: 4px;\n        font-size: 25px;\n    }\n\n    .expired-token__press-enter {\n        display: inline-table;\n        margin-left: 2%;\n\n        .congratulations__press-enter-tex {\n            margin: 0px;\n            max-width: 100%;\n            font-weight: unset;\n            font-size: 12px;\n            line-height: 16px;\n            color: rgb(34, 35, 35);\n            font-family: sans-serif;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
